module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_165517_HDR-removebg-preview-40376db2b7df8d36f520b484c4ff3221.png";